var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowIncomingIcon = function SvgArrowIncomingIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#30A0C4",
    fillRule: "evenodd",
    d: "M1 9.439V4.03c0-.314.257-.561.584-.561.328 0 .585.247.585.561v4.062l7.225-6.935C9.51 1.044 9.65 1 9.814 1c.164 0 .305.044.422.157.234.224.234.583 0 .785L2.987 8.878H7.22c.327 0 .584.246.584.56 0 .315-.257.562-.584.562H1.584C1.257 10 1 9.753 1 9.439z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowIncomingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-incoming-icon.995110cd02174c4dfb6dcc7b4ec4c6f8.svg";